<div class="p-mb-4">
    <app-shared-detail-block  [moduleName]="'Product'"
        [column]="cols" [data]="serialDetails" (openLocationDialog)="openLocationDialog($event)">
    </app-shared-detail-block>
</div>

<hr *ngIf="detailsCol?.length > 0">   

<div class="p-grid" *ngIf="detailsCol?.length > 0">
    <div class="p-col-12 p-p-0">
        <h5 style="background:#eee;padding:0.5rem;border-bottom:1px solid #ddd;">Transaction Details</h5>
    </div>
</div>
<div class="p-grid p-mb-2" *ngFor="let s of detailsCol;let i=index;" 
[ngClass]="{'bordered-section1' : i==0 , 'bordered-section2' : i==1 , 'bordered-section3' : i==2, 'bordered-section4' : i==3 }">
    <div class="p-col-6 p-py-0 p-mb-3" style="border-right:2px solid #ddd;">
        <ng-container *ngFor="let m of s[0]?.section;let ii=index;">
            <div class="p-d-flex p-mb-1 p-p-2"  
            [style.border-bottom]="ii == s[0]?.section.length-1 ? 'none' :'1px solid #ddd'">
                <div style="width: 25%;"><strong>{{m.header}}</strong></div>
                <div style="width: 75%;">
                    <ng-container [ngSwitch]="m.datetype">
                        <ng-container *ngSwitchCase="'decimal'">
                            {{s[0][m.field] | customNumberFormat: length | currencySymbol}}
                        </ng-container>
                        <ng-container *ngSwitchCase="'datetime'">
                            {{s[0][m.field] | date:'MM/dd/yyyy'}}              
                        </ng-container>
                        <ng-container *ngSwitchDefault>
                            <span [ngClass]="{'report-link': isPopupAllowed(m.field)}"
                            (click)="isPopupAllowed(m.field) ? detailsView(s[0], m.field) : null">
                            {{s[0][m.field]}}
                            </span>
                        </ng-container>
                    </ng-container>
                </div>
            </div>
        </ng-container>
    </div>
    <div class="p-col-6 p-py-0 p-mb-3" style="border-right:2px solid #ddd;" *ngIf="s[1]">
        <ng-container *ngFor="let m of s[1].section;let ii=index;">
            <div class="p-d-flex p-mb-1 p-p-2"  
            [style.border-bottom]="ii == s[1]?.section.length-1 ? 'none' :'1px solid #ddd'">
                <div style="width: 25%;"><strong>{{m.header}}</strong></div>
                <div style="width: 75%;">
                    <ng-container [ngSwitch]="m.datetype">
                        <ng-container *ngSwitchCase="'decimal'">
                            {{s[1][m.field] | customNumberFormat: length | currencySymbol}}
                        </ng-container>
                        <ng-container *ngSwitchCase="'datetime'">
                            {{s[1][m.field] | date:'MM/dd/yyyy'}}              
                        </ng-container>
                        <ng-container *ngSwitchDefault>
                            <span [ngClass]="{'report-link': isPopupAllowed(m.field)}"
                            (click)="isPopupAllowed(m.field) ? detailsView(s[1], m.field) : null">
                            {{s[1][m.field]}}
                            </span>
                        </ng-container>
                    </ng-container>
                </div>
            </div>
        </ng-container>
    </div>
</div>


<!-- Inventory Transfer Details -->
<p-dialog header="Inventory Transfer Details" [(visible)]="displayTransfer" [modal]="true" [responsive]="true"
    [style]="{ width: '60vw' }">
    <app-inventory-transfer-view [inventoryTransferId]="inventorytransferId"></app-inventory-transfer-view>
    <p-footer *ngIf="isView">
        <button type="button" pButton (click)="onDialogClose()" label="Cancel"
            class="p-button-secondary"></button>
    </p-footer>
</p-dialog>

<!-- Inventory Adjustment Details -->
<p-dialog class="customHeader" header="Inventory Adjustment Details" [(visible)]="displayAdjustment" [modal]="true" [responsive]="true" [closable]="true"
    [style]="{ width: '60vw' }" (onHide)="onDialogClose()">
    <div>
        <app-inventory-adjustment-view [inventoryAdjustmentId]="inventoryAdjustmentId"></app-inventory-adjustment-view>
    </div>
    <p-footer *ngIf="isView">
        <button type="button" pButton (click)="onDialogClose()" label="Cancel" class="p-button-secondary"></button>
    </p-footer>
</p-dialog>


<app-inventory-module-overview-dialogs
    *ngIf="displayInventoryOverview"
    [displayOverview]="displayInventoryOverview"
    [overviewRefId]="inventoryOverviewRefId"
    [overviewRefNumber]="inventoryOverviewRefNumber"
    [overviewModule]="inventoryOverviewModule" [trackingOptions]="trackingOptions"
    (onCancel)="closeViewPopup()">
</app-inventory-module-overview-dialogs>

<app-edit-account *ngIf="displayAccountViewEdit" [displayEditViewDialog]="displayAccountViewEdit" [displayView]="true"
    [selectedAccountId]="selectedAccountId" [selectedChannelId]="selectedAccountChannelId"
    (closeModal)="closeAccountViewEditModal()">
</app-edit-account>

<app-location-view-edit 
*ngIf="displaylocationView" [displaylocationView]="displaylocationView" 
[location]="location"  (closeLocationView)="closeLocationView($event)"
>
</app-location-view-edit>

<app-vendor-view-edit *ngIf="isSelecteddVendor"  [selectedVendor]="selecteddVendor"
     (closeDialog)="resetDialog($event)">
</app-vendor-view-edit>

<div *ngIf="loadingSpinner" class="spinner-container">
    <p-progressSpinner [style]="{width: '50px', height: '50px'}" styleClass="custom-spinner" animationDuration=".5s"></p-progressSpinner>
  </div>
  